import { DATE_FORMAT_API } from '@/constants/dateTimeFormats';
import moment from 'moment';

export const reportsMorningMonitoring = {
    namespaced: true,

    state: {
        dateDailyModel: {
            startDate: null
        },

        dateModel: {
            startDate: moment().subtract(1, 'months').format(DATE_FORMAT_API),
            endDate: moment().format(DATE_FORMAT_API)
        },

        filter: {
            squads: [],
            tags: [],
            focuses: []
        }
    },

    getters: {
        getDateDailyModel(state) {
            return state.dateDailyModel.startDate;
        },

        getStartDateModel(state) {
            return state.dateModel.startDate;
        },

        getEndDateModel(state) {
            return state.dateModel.endDate;
        },

        getFilterModel(state) {
            return state.filter;
        }
    },

    actions: {
        setDateDaily(context, payload) {
            Vue.set(context.state.dateDailyModel, 'startDate', payload);
        },

        setStartDate(context, payload) {
            Vue.set(context.state.dateModel, 'startDate', payload);
        },

        setEndDate(context, payload) {
            Vue.set(context.state.dateModel, 'endDate', payload);
        },

        setTags(context, payload) {
            Vue.set(context.state.filter, 'tags', payload);
        }
    }
};
